import __base_store from '@/store/__base_store'

/**
 * Store de tipos de envase.
 */
export default __base_store({
	state: {
		model_name: 'tipo_envase',
	},
})

